import BuyBox from "./buy-box";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function TournamentBuyBox({
  disabled,
  isGameBoard,
  groupBettingPool,
  groupBettingPoolEnter,
  session,
  sessionShowLogin
}) {
  var price = { usd: groupBettingPool.get("entry_amount") };
  return (
    <BuyBox
      badge={<PoolCannotEnterBadge groupBettingPool={groupBettingPool} />}
      detailsUrl="/player-pool-tickets/"
      disabled={disabled}
      enterError={groupBettingPool.get("enterError")}
      entering={groupBettingPool.get("entering")}
      isGameBoard={isGameBoard}
      isOpen={groupBettingPool.get("open")}
      itemsPurchasedByUser={groupBettingPool.get("my_entries")}
      itemsRemaining={groupBettingPool.get("remaining_entries")}
      maxItemsPerUser={groupBettingPool.get("max_entries_per_user")}
      onEnter={(quantity, currency) => groupBettingPoolEnter(groupBettingPool.get("id"), quantity, currency)}
      price={price}
      session={session}
      sessionShowLogin={sessionShowLogin} />
  );
});


var PoolCannotEnterBadge = pure(function PoolCannotEnterBadge({ groupBettingPool }) {
  if (!groupBettingPool.get("open")) {
    return <InProgressBadge />;
  }
  if (groupBettingPool.get("max_entries_per_user") - groupBettingPool.get("my_entries") === 0) {
    return <MaxEntriesReachedBadge />;
  }
  if (groupBettingPool.get("remaining_entries") === 0) {
    return <GameIsFullBadge />;
  }
  return null;
});

var MaxEntriesReachedBadge = pure(function MaxEntriesReachedBadge() {
  return (
    <span className="badge badge--red">
      <i className="dw-blocked" />

      <span>
        Max entries reached.
      </span>
    </span>
  );
});

var GameIsFullBadge = pure(function GameIsFullBadge() {
  return (
    <span className="badge badge--red">
      <i className="dw-blocked" />

      <div>
        This pool is full!
      </div>
    </span>
  );
});

var InProgressBadge = pure(function InProgressBadge() {
  return (
    <span className="badge badge--lime">
      <i className="dw-time-slot" />

      <div>
        This pool is in progress!
      </div>
    </span>
  );
});
